// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CateMenu_wrapper__3-Ito","title":"CateMenu_title__1pbzy"};